<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import { ShoppingCart, Location, Merchant, Account, util } from './../../functions.js';
import LocationAPI from './../../api/location.js';
import ShippingAPI from './../../api/shipping.js';
import PaymentAPI from './../../api/payment.js';
import OrderAPI from './../../api/order.js';
import AccountAPI from './../../api/account.js';
import ProductAPI from './../../api/product.js';

import HeaderFive from './../shared/HeaderFive.vue';
import Footer from './../shared/Footer.vue';
import ConfirmDialogue from './../shared/ConfirmDialogue.vue'
import AlertDialogue from './../shared/AlertDialogue.vue'
import AddToCartDialogue from './../shared/AddToCartDialogue.vue'
import QuickviewDialogue from './../shared/QuickviewDialogue.vue'

import { _toNumber, _uniqBy } from 'lodash';
import moment from 'moment';
export default {
  name: 'Checkout',
  components: {
    DatePicker ,
    Footer,
    HeaderFive,
    ConfirmDialogue,
    AlertDialogue,
    AddToCartDialogue,
    QuickviewDialogue
  },
   watch: {
     voucher_code (new_value, old_value)
     {
       if(this.voucher_promo)
       {
        if( (this.voucher_promo.promo_type).toLowerCase() == 'free gift')
        {
            this.loadFreeGifts();
        }
        else if( (this.voucher_promo.promo_type).toLowerCase() == 'cart discount')
        {
          this.getProductDiscounts();
            this.calculateCartDiscount();
        }
        else if( (this.voucher_promo.promo_type).toLowerCase() == 'price discount')
        {
          this.getProductDiscounts();
           this.calculateCartDiscount();
        }
        else if((this.voucher_promo.promo_type).toLowerCase() == 'shipping discount')
        {
           this.calculateShippingFee();

        }

       }
      else
      {

        this.loadFreeGifts();
        this.getProductDiscounts();
        this.calculateCartDiscount();
        this.calculateShippingFee();
      }

     },
     products (new_value, old_value)
     {
       console.log("product_update");
       console.log(old_value.length);
       console.log(new_value.length);
       console.log(this.checkout_products_count);
       if(this.products.length)
       {
           if(this.checkout_products_count > new_value.length)
           {
             // If there's a product removed from the cart while in checkout page, reload promos and voucher

              if(this.voucher_code  != '')
              {
                this.input_voucher = this.voucher_code;
                this.voucher_code = '';
                this.voucher_promo = null;

                // Let the voucher_code watch load the free gift, product discount, cart discount and calculate shipping fee
              }
              else
              {
                  this.loadFreeGifts();
                  this.getProductDiscounts();
                  this.calculateCartDiscount();
                  this.calculateShippingFee();
              }

           }
       }
       else
       {
         this.$router.push("/cart?m=products_not_found")
       }
     },
     new_address (new_value, old_value)
     {
       if(new_value == true)
       {
          if(this.is_logged_in)
          {
            this.province = structuredClone(Location.location.province);
            this.city = structuredClone(Location.location.city);
            this.barangay = structuredClone(Location.location.barangay);
            this.address = '';
            this.landmark = '';
          }
          else
          {
            this.province = structuredClone({
                province_code: Account.info.province.province_code,
                province_name: Account.info.province.province_name,
               });

               this.city = structuredClone({
                city_code: Account.info.city.city_code,
                city_name: Account.info.city.city_name,
               });

               this.barangay = structuredClone({
                brgy_code:  Account.info.barangay.brgy_code,
                brgy_name: Account.info.barangay.brgy_name,
               });
              this.address = Account.info.address;
              this.landmark = '';
          }
       }
       else
       {
         if(this.active_account_address != null)
         {
            var active_address = this.my_addresses[this.active_account_address];
              this.province = structuredClone({
                province_code: active_address.province_code,
                province_name: active_address.province_name,
               });

               this.city = structuredClone({
                city_code: active_address.city_code,
                city_name: active_address.city_name,
               });

               this.barangay = structuredClone({
                brgy_code: active_address.brgy_code,
                brgy_name: active_address.brgy_name,
               });
              
              this.address = active_address.addresses;
            // this.setCustomerInfo(active_address.customer_id);

         }

       }
     },
    show_error (new_value, old_value) {
      // Autoclose Error after 5 Seconds
      if (new_value == true) {
        setTimeout(() => {
          this.show_error = false
          this.error_message = ''
        }, 5000)
      }
    },
    delivery_time (new_value, old_value)
    {
       this.checkDeliveryCutoff(new_value);
    },
    pickup_method (new_value, old_value)
    {
      this.calculateShippingFee();
    }
  },
  computed: {
    subTotal() {
        var initial_total = 0;
        var final_total = 0;
          console.log(this.products);
        // Calculate Iniitial Total - Product Price and Discounted Price without Minimum Spend
        this.products.forEach((product, product_index) => {
            var selling_price = 0;
        

        if(product.product.sale_type == 'default')
        {

          selling_price = (product.product.product_price);
        }
        else
        {
        
      
              var has_price_off_promo = false;
              var price_off_promo_index = 0;
              if(product.product.promo)
              {
                product.product.promo.forEach((promo, promo_index)=>{
                  // console.log(typeof promo);
                  if(typeof promo == 'object' && !Array.isArray(promo))
                  {
                    if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                    {
              

                       var passed_product_requirements = 0;
                       promo.required_items.forEach((ri,ri_index)=>{
                           ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                            if(p.product.sku == ri.sku_id)
                            {
                              passed_product_requirements+=1;
                            }
                          });
                        });

                      if(passed_product_requirements == promo.required_items.length)
                      {
                         if(promo.promo_minimum_amount <= 0)
                         {
                            if(has_price_off_promo)
                            {
                              if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                              {
                                price_off_promo_index = promo_index;
                                    has_price_off_promo = true;
                              }

                            }
                            else
                            {

                       
                               price_off_promo_index = promo_index;
                                 has_price_off_promo = true;
                              }
                          }
                        
                     
                      }
                    }
                  }
                });
              }

             
            if(has_price_off_promo)
            {
   
  
                selling_price =   (product.product.sale_price);
                 
            }
            else
            {

              selling_price =(product.product.product_price == parseFloat(product.product.product_sale_price) ? (product.product.product_price ) : (product.product.product_sale_price));
            }


        }
       
          console.log(product);
            // From Voucher
            if(product.voucher_discount)
            {
              selling_price = parseFloat(product.voucher_discount.promo_price);
            }

            initial_total = initial_total + (product.quantity * selling_price);
        });

        // console.log("Initial Total");
        // console.log(initial_total);

         // Calculate Final Total - Product Price and Discounted Price with or without Minimum Spend
        this.products.forEach((product, product_index) => {
            var selling_price = 0;

         if(product.product.sale_type == 'default')
        {
          selling_price = (product.product.product_price);
        }
        else
        {
         
              var has_price_off_promo = false;
              var price_off_promo_index = 0;

              if(product.product.promo){
                product.product.promo.forEach((promo, promo_index)=>{
                  if(typeof promo == 'object' && !Array.isArray(promo)) {
                    if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                    {
                 

                       var passed_product_requirements = 0;
                       promo.required_items.forEach((ri,ri_index)=>{
                         ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                          if(p.product.sku == ri.sku_id)
                          {
                            passed_product_requirements+=1;
                          }
                        });
                      });

                      if(passed_product_requirements == promo.required_items.length)
                      {
                        
                          if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                          {

                            if(has_price_off_promo)
                            {

                              if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                              {
                                price_off_promo_index = promo_index;
                                    has_price_off_promo = true;
                              }

                            }
                            else
                            {

                               price_off_promo_index = promo_index;
                                 has_price_off_promo = true;
                              }
                          }
                     
                      }
                    }
                  }
                });
              }

            if(has_price_off_promo)
            {
               selling_price =  (product.product.sale_price);
             }
             else
             {
               selling_price =  (product.product.product_price == parseFloat(product.product.product_sale_price) ? (product.product.product_price ) : (product.product.product_sale_price));
             }

        }
       

            // From Voucher
            if(product.voucher_discount)
            {
              selling_price = parseFloat(product.voucher_discount.promo_price);
            }

            final_total = final_total + (product.quantity * selling_price);
        });

        // console.log("Final Total");
        //     console.log(final_total);
        //     console.log("calculated");

        return final_total;
    },
    orderTotal() {
      let overall_total = 0;
      let subtotal = 0;
      let delivery_fee = 0;

      subtotal = (this.subTotal - this.cart_discount);
      if(subtotal <= 0)
      {
        subtotal = 0;
      }

      if(this.delivery_promo.length)
      {
        delivery_fee = this.discounted_delivery_fee;
      }
      else
      {
        delivery_fee = this.delivery_fee;
      }

      overall_total = subtotal + delivery_fee;

      return overall_total;
    },
  },
  data () {
    return {
        ShoppingCart,

        submit: false,
        error_message: '',
        show_error: '',
        shipping_method_list: [],
        calendar_disabled_dates: [],
        payment_method_list: [],
        is_logged_in: false,
        active_account_address: null,

        customer_id: '',
        first_name: '',
        last_name: '',
        email_address: '',
        mobile_number: '',
        tel_number: '',
        my_addresses: [],
        new_address : false,
        province: {
          province_name: '',
          province_code: '',
        },
        city: {
          city_name: '',
          city_code: '',
        },
        barangay: {
          brgy_code: '',
          brgy_name: '',
        },
        province_list: [],
        city_list: [],
        barangay_list: [],
        address: '',
        landmark: '',
        notes: '',
        calculating_shipping_fee: false,
        pickup_method: 0,
        pickup_date: moment(),
        delivery_time: "12:00 AM",
        delivery_fee: 0,
        discounted_delivery_fee: 0,
        free_delivery: false,
        delivery_cutoff: false,
        delivery_discount: 0,
        delivery_promo: [],
        payment_method: 3,
        products: [],
        free_gifts: [],
        cart_discount: 0,
        cart_promo: [],
        voucher_code: '',
        input_voucher: '',
        voucher_promo: null,
        loading_voucher: false,
        order_notes: '',
        loaded: false,
        checkout_products_count: 0
    }
  },
  async mounted()
  {

    try {
      this.loaded = false;
      var load_provinces = await this.loadProvinces();
      var login_id = Account.getLoginId();
      var token = Account.getToken();
      var customer_id = Account.getCustomerID();
      if(login_id != '' && token != '')
      {
        this.is_logged_in = true;
         AccountAPI.ping(login_id, token)
        .then((ping_result)=>{
           if(ping_result.status == 'success')
           {
             this.customer_id = customer_id;
             this.setCustomerInfo(customer_id)
             .then((account_info_result)=>{
               this.my_addresses = Account.addresses;
               this.active_account_address = 0;

               var in_address = false;
               this.my_addresses.forEach((address, address_index)=>{
                if(address.brgy_code == Location.location.barangay.brgy_code)
                {
                  in_address = true;
                  this.active_account_address = address_index;
                  this.customer_id = address.customer_id;
                }
               });


               if(in_address)
               {
                 this.province = structuredClone({
                  province_code: this.my_addresses[this.active_account_address].province_code,
                  province_name: this.my_addresses[this.active_account_address].province_name,
                 });

                 this.city = structuredClone({
                  city_code: this.my_addresses[this.active_account_address].city_code,
                  city_name: this.my_addresses[this.active_account_address].city_name,
                 });

                 this.barangay = structuredClone({
                  brgy_code: this.my_addresses[this.active_account_address].brgy_code,
                  brgy_name: this.my_addresses[this.active_account_address].brgy_name,
                 });
               }
               else
               {
                this.new_address = true;
                this.province = structuredClone(Location.location.province);
               this.city = structuredClone(Location.location.city);
               this.barangay = structuredClone(Location.location.barangay);
                this.loadCities(this.province.province_code);
                this.loadBarangay(this.city.city_code);
               }
               
                this.loadShippingTime();

                this.loadCities(this.province.province_code);
                this.loadBarangay(this.city.city_code);

                 let load_product_data = this.loadProductsData();
                 load_product_data.then((loaded_product)=>{
                   console.log(loaded_product);
                  if(loaded_product.status == 'success')
                  {
                    this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products = loaded_product.products;
                    this.ShoppingCart.setCart(this.ShoppingCart.cart);

                    this.products = this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products;
                    this.checkout_products_count = this.products.length;
                  }
                  else{
                    this.products = this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products;
                     this.checkout_products_count = this.products.length;
                  }


                  var load_shipping_methods = this.loadShippingMethods();
                  var load_payment_methods = this.loadPaymentMethods();

                   // this.loadVoucher();
                  this.loadFreeGifts();
                  this.getProductDiscounts();
                  this.calculateCartDiscount();
                    this.loaded = true;
                });
               

               setInterval(()=>{
                this.loadShippingTime();
               },60000)
               this.calculateShippingFee();
             });
           }
           else
           {
             this.$router.push('/login?redirect=checkout&m=session_expired');
           }
        });
      }
      else
      {
        this.is_logged_in = false;
        this.new_address = true;

        this.customer_id = customer_id;
        this.first_name = Account.info.first_name;
        this.last_name = Account.info.last_name;
        this.email_address = Account.info.email_address;
        this.mobile_number = Account.info.mobile_number;
        this.tel_number = Account.info.telephone_number;
        this.address = Account.info.address;

         this.province = structuredClone(Location.location.province);
         this.city = structuredClone(Location.location.city);
         this.barangay = structuredClone(Location.location.barangay);

          this.loadShippingTime();

          this.loadCities(this.province.province_code);
          this.loadBarangay(this.city.city_code);

            let load_product_data = this.loadProductsData();
           load_product_data.then((loaded_product)=>{
          
            if(loaded_product.status == 'success')
            {
              this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products = loaded_product.products;
              this.ShoppingCart.setCart(this.ShoppingCart.cart);

              this.products = this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products;
               this.checkout_products_count = this.products.length;
            }
            else{
              this.products = this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products;
               this.checkout_products_count = this.products.length;
            }


      var load_shipping_methods = this.loadShippingMethods();
      var load_payment_methods =  this.loadPaymentMethods();

              // this.loadVoucher();
            this.loadFreeGifts();
            this.getProductDiscounts();
            this.calculateCartDiscount();
            this.loaded = true;
          });
        

         setInterval(()=>{
          this.loadShippingTime();
         },60000)
         this.calculateShippingFee();

      }


    } catch (error) {
      console.log(error);
    }


      
     
  },
  methods: {
    getProductDiscounts()
    {
      if(this.voucher_promo && (this.voucher_promo.promo_type).toLowerCase() == 'price discount')
      {
        let new_product_list = [];

         this.products.forEach((p,p_index)=>{
          var has_product_discount = false;
          var discount_data = null;

          this.voucher_promo.products.forEach((discounted,discounted_index)=>{
            if(p.product.sku == discounted.sku_id)
            {
              if(discounted.promo_price)
              {
                has_product_discount = true;
                discount_data = discounted;
              }
            }
          });

          if(has_product_discount)
          {
            // p.voucher_discount = discount_data;
            this.$set(p,'voucher_discount',discount_data);
            // new_product_list.push(p);
          }
          // else
          // {
          //   new_product_list.push(p);
          // }
        });

          // this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products = new_product_list;
          // this.ShoppingCart.setCart(this.ShoppingCart.cart);

          // this.products = this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products;
      }
      // else
      // {
      //   let new_product_list = [];
      //   this.products.forEach((p,p_index)=>{
      //     new_product_list.push({
      //       quantity: p.quantity,
      //       product: p.product
      //     });
      //   });
        
      //     //  this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products = new_product_list;
      //     // this.ShoppingCart.setCart(this.ShoppingCart.cart);

      //     // this.products = this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products;
      // }
    },
    loadFreeGifts()
    {
      this.free_gifts = [];
      var free_gifts_promos = [];

      // Check Product Free Gift Data
      this.products.forEach((p,p_index)=>{
        if(p.product.promo)
        {
          p.product.promo.forEach((promo, promo_index)=>{
            if(typeof promo == 'object' && !Array.isArray(promo)) {
            if( (promo.promo_type).toUpperCase() == 'FREE GIFT')
            {
              free_gifts_promos.push(promo);
            }
          }
          });
        }
      });

      // Check Voucher Free Gift Data
      if(this.voucher_promo != null && (this.voucher_promo.promo_type).toUpperCase() == 'FREE GIFT')
      {
        free_gifts_promos.push(this.voucher_promo);
      }

      // free_gifts_promos = _.uniqBy(free_gifts_promos, (promo)=>promo.promo_code);

      // Get first latest value of array when getting unique free gift promo
      free_gifts_promos = _.reverse(_.uniqBy(_.reverse(free_gifts_promos), (promo)=>promo.promo_code));

      free_gifts_promos.forEach((promo, promo_index)=>{
        if(promo.free_items && promo.free_items.length)
        {

            var passed_product_requirements = 0;
            if(promo.required_items && promo.required_items.length)
            {
              promo.required_items.forEach((ri,ri_index)=>{
                 ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                  if(p.product.sku == ri.sku_id)
                  {
                    passed_product_requirements+=1;
                  }
                });
              });
            }

          promo.free_items.forEach((free_item, free_item_index)=>{
          
            if(ShoppingCart.getCartTotal(0) >= promo.promo_minimum_amount)
            {
              if(passed_product_requirements == (promo.required_items ? promo.required_items.length : 0))
              {
                this.free_gifts.push({
                  product_name: free_item.product_name,
                  product_image: free_item.product_image,
                  quantity: free_item.quantity,
                });
              }
            }
          })
        }
        else if(promo.free_gift && promo.free_gift.length)
        {
          var passed_product_requirements = 0;
          if(promo.required_items && promo.required_items.length)
          {
            promo.required_items.forEach((ri,ri_index)=>{
               ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                if(p.product.sku == ri.sku_id)
                {
                  passed_product_requirements+=1;
                }
              });
            });
          }
          promo.free_gift.forEach((free_gift, free_gift_index)=>{
         
            if(ShoppingCart.getCartTotal(0) >= promo.promo_minimum_amount)
            {
             if(passed_product_requirements == (promo.required_items ? promo.required_items.length : 0))
              {
                this.free_gifts.push({
                  product_name: free_gift.product_name,
                  product_image: free_gift.product_image,
                  quantity: free_gift.quantity,
                });
              }
            }
          })

        }
      });
      

    },
    selectMyAddress(event)
    {
      var address_index = event.target.value;
   
      if (address_index === 'new') {
      // Handle new address creation logic
      this.new_address = true; // Or any other logic for new address input
      this.clearAddressFields(); // Optional: clear existing fields
    } else {
      // Existing address selected
      var address = this.my_addresses[address_index];
      this.new_address = false; // Deselect new address mode
      this.setCustomerInfo(address.customer_id);
    }

    },
    async setCustomerInfo(customer_id)
    {
      return new Promise((resolve, reject) => {
        // var address_index = event.target.value;
        // var address = this.my_addresses[address_index];
   
        // this.province.province_code = address.prov.psgcCode;
        // this.province.province_name = address.prov.provDesc;
        // this.city.city_code = address.citymun.citymunCode;
        // this.city.city_name = address.citymun.citymunDesc;
        // this.barangay.brgy_code = address.brgy.brgyCode;
        // this.barangay.brgy_name = address.brgy.brgyDesc;
        // this.address = address.location;
        // this.landmark = address.landmark;
        try {
          var token = Account.getToken();
          AccountAPI.accountInfo(token, customer_id)
           .then((account_info_result)=>{
             this.first_name = account_info_result.data.first_name;
             this.last_name = account_info_result.data.last_name;
             this.email_address = account_info_result.data.email;
             this.mobile_number = account_info_result.data.mobile_number;
             this.tel_number = account_info_result.data.telephone_number;
             this.address = account_info_result.data.addresses.address;
              this.province.province_code = account_info_result.data.addresses.psgcCode;
              this.province.province_name = account_info_result.data.addresses.provName;
              this.city.city_code = account_info_result.data.addresses.cityCode;
              this.city.city_name = account_info_result.data.addresses.cityName;
              this.barangay.brgy_code = account_info_result.data.addresses.brgyCode;
              this.barangay.brgy_name = account_info_result.data.addresses.brgyName;

             resolve(true);
           });

        } catch (error) {
          console.log(error);
        }
      });
    },
    async loadShippingTime()
    {
      var shipping_time_request = ShippingAPI.getShippingTime();
      shipping_time_request.then((response)=>{
          this.delivery_time = response.time;
         this.checkDeliveryCutoff(response.time);
      });
    },
    selectShippingMethod(shipping_method)
    {
      this.pickup_method = shipping_method.id;
    },
    checkDeliveryCutoff(timestring)
    {
      var deliverytime = moment(timestring, "hh:mm A");
      var cutoff_from = moment("5:00 PM", "hh:mm A");
      var cutoff_to = moment("11:59 PM", "hh:mm A");

      if(deliverytime.isAfter(cutoff_from) && deliverytime.isBefore(cutoff_to))
      {
        this.delivery_cutoff = true;
      }
      else
      {
        this.delivery_cutoff = false;       
      }
    },
    disabledDateRange: function (date) {
        var min_date = new Date();
        var max_date = new Date();
        max_date.setDate(max_date.getDate() + 5);

         return date < min_date || date > max_date;
     },
     getShippingMethodCode(shipping_method_id)
     {
       var ship_method = '';
       this.shipping_method_list.forEach((shipping_method, shipping_method_index)=>{
         if(shipping_method.id == shipping_method_id)
         {
           ship_method = shipping_method.pickup_code;
         }
       });
       return ship_method;
     },
     async loadVoucher()
     {
      if ((sessionStorage.getItem('gsm_vchr'))) {
        var session_voucher = (sessionStorage.getItem('gsm_vchr'));
        this.input_voucher = session_voucher;
        this.applyVoucher();
      }
     },
     async removeVoucher()
     {
      this.input_voucher = '';
      this.voucher_code = '';
      sessionStorage.removeItem('gsm_vchr', this.voucher_code);
      this.voucher_promo = null;
     },
     async applyVoucher()
     {
       var order_total = this.subTotal;
       var shipping_total = 0;
       var barangay_code = this.barangay;
       var merchant_orders = [];
       this.products.forEach((product,product_index)=>{
         merchant_orders.push({
           quantity: product.quantity,
           sku_id: product.product.sku,
           product_price: product.product.product_price,
           sale_price: product.product.sale_price
         });
       });

       this.loading_voucher = true;

       if(order_total <= 0)
       {
         console.log("Zero Order Total");
               this.loading_voucher = false;
       }
       else if(this.shipping_method_list.length <= 0)
       {
         console.log("Shipping Methods Not Loaded Yet")
               this.loading_voucher = false;
       }
       else if(this.pickup_method == 0)
       {
         console.log("Shipping Method not selected");
         this.loading_voucher  = false;
       }
       else if(barangay_code == "")
       {
         console.log("Checkout Address Not Loaded Yet");
               this.loading_voucher = false;
       }
       else if(merchant_orders.length <= 0)
       {
         console.log("Orders Not Found");
               this.loading_voucher = false;
       }
       else
       {
           var voucher_code = this.input_voucher;
           var customer_id   = Account.getCustomerID();
           var applyvoucher_request = OrderAPI.applyVoucher(order_total, this.discounted_delivery_fee, barangay_code, merchant_orders, voucher_code, customer_id);
           applyvoucher_request.then((response)=>{
             if(response.status == 'success' && response.valid_voucher == true)
             {
                this.voucher_code = response.voucher_code;
                this.voucher_promo = response.promo[0];
                sessionStorage.setItem('gsm_vchr', this.voucher_code);

                this.loading_voucher = false;
             }
             else
             {

                this.show_error = true;
                if(response.remarks != "")
                {

                  this.error_message = response.remarks;
                }
                else
                {
                  this.error_message = "Please enter a valid voucher code";
                }
                this.loading_voucher = false;
             }
           });

       }

     
     },
     async calculateCartDiscount()
     {
       try {
     
             var merchant_orders = [];
                this.products.forEach((product,product_index)=>{
                 merchant_orders.push({
                   quantity: product.quantity,
                   product_price: product.product.product_price,
                   sku_id: product.product.sku,
                 });
               });

                var customer_id = Account.getCustomerID();


             var cart_discount_request = OrderAPI.getOrderDiscount(this.province.province_code, this.city.city_code, this.barangay.brgy_code, merchant_orders, customer_id, this.voucher_code);
           cart_discount_request.then((response)=>{
             if(response.status == 'success')
             {
               this.cart_discount = _.toNumber(response.cart_discount);
               
               if(this.cart_discount > 0)
               {  
                 this.cart_promo = response.promo;
               }
             }
           });

         
        
       } catch (error) {

       }
     },
     async loadProductsData()
     {
        return new Promise((resolve, reject) => {
            var load_products_response = {
              status: 'failed',
              products: [],
              remarks: '',
            };

           try {


                 var cart_product = this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products;
                 var merchant_orders = [];
                  cart_product.forEach((product,product_index)=>{
                    var sku_raw = product.product.sku.substring(0, product.product.sku.indexOf("-"));
                     merchant_orders.push(sku_raw);
                  });

                  var barangay_code = Location.location.barangay.brgy_code;
                  var products_request = ProductAPI.getProducts(barangay_code, '', '', '', false, false, 'best_seller', 'none', '', 12, 0, merchant_orders)
                    products_request.then((response) => {
                        if(response.products.length)
                        {
                          var update_product_data = response.products;

                          update_product_data.forEach((product_data, product_data_index)=>{
                              cart_product.forEach((product,product_index)=>{
                                if(product.product.sku == product_data.sku)
                                {
                                  product.product = product_data;
                                  // product.updated = true;
                                }
                              });
                          });


                            load_products_response.status = "success";
                            load_products_response.remarks = "Product Data Updated";
                            load_products_response.products = cart_product;
                           resolve(load_products_response);
                        }
                        else
                        {
                            load_products_response.remarks = "No Products Found";
                             resolve(load_products_response);
                        }
                    // this.products = response.products;
                  });     
           } catch (error) {
               console.log(error);
               load_products_response.remarks = error;
               resolve(load_products_response);
           }
       });
     },
     async calculateShippingFee()
     {
       this.calculating_shipping_fee = true;
       try {
         if(this.pickup_method != 0)
         {
             var merchant_orders = [];
                this.products.forEach((product,product_index)=>{
                 merchant_orders.push({
                   quantity: product.quantity,
                   sku_id: product.product.sku,
                   product_price: product.product.product_price
                 });
               });

             this.delivery_fee = 0;
             this.free_delivery = false;
             this.delivery_promo = [];

             var customer_id = Account.getCustomerID();
             console.log(customer_id);
             var shippingfee_request = ShippingAPI.getShippingFee(this.province.province_code, this.city.city_code, this.barangay.brgy_code, this.getShippingMethodCode(this.pickup_method), ShoppingCart.getTotalCartWeight(), merchant_orders, customer_id ,this.voucher_code);
             shippingfee_request.then((response)=>{
             if(response.status == 'success')
             {

               // Check Regular Shipping Fee
               this.delivery_fee = _.toNumber(response.delivery_charge);
               this.discounted_delivery_fee = _.toNumber(response.delivery_charge);

               this.free_delivery = response.free_delivery;
               if(this.free_delivery)
               {
                 this.delivery_fee = 0;
               }

              // Check Promo Shipping Fee
               if(response.promo.length)
               {
                this.delivery_promo = response.promo;
                this.delivery_fee = _.toNumber(this.delivery_promo[response.promo.length - 1].original_delivery_charge);
                this.discounted_delivery_fee = this.delivery_promo[response.promo.length - 1].discounted_delivery_charge;
                if(this.discounted_delivery_fee <= 0)
                {
                  this.discounted_delivery_fee = 0;
                  this.free_delivery = true;
                }
               }

               this.calculating_shipping_fee = false;
              
               
             }
           });

         }
         else
         {
           this.calculating_shipping_fee = false;
         }
        
       } catch (error) {
         this.calculating_shipping_fee = false;
       }
     },
     async merchantProductChecking()
     {
        return new Promise((resolve, reject) => {
          var validation_result = {
            status: 'success',
            message: 'Valid Products-Merchant'
          };

          if(this.barangay.brgy_code != Location.location.barangay.brgy_code)
          {

              var change_merchant = ShoppingCart.changeMerchant(this.barangay.brgy_code);
              change_merchant.then((updated_products)=>{


                if(updated_products.status == 'success' && updated_products.products.length && !updated_products.updated)
                {
                  resolve(validation_result)
                }
                else
                {
                      let displayed_product_data = {
                            subtotal: 0,
                            products: []
                        };

                         this.products.forEach((product,product_index)=>{
                            var p = {
                              product: null,
                              quantity: 0
                            };

                            p.product = product.product;
                            updated_products.products.forEach((new_product, new_product_index)=>{
                                var sku_raw = product.product.sku.substring(0, product.product.sku.indexOf("-"));
                                if(new_product.product.sku.includes(sku_raw))
                                {
                                  p.quantity = new_product.new_qty;
                                }
                            });

                            displayed_product_data.subtotal += (p.product.product_price) * p.quantity;
                            displayed_product_data.products.push(p);
                        });


                       let product_list_message = "<ul class='updated-product-list'>";
                        displayed_product_data.products.forEach((dp, dp_i)=>{
                          // if(dp.quantity>0)
                          // {
                            product_list_message = product_list_message + "<li>" + dp.quantity + " x " + dp.product.product_name + "</li>";
                          // }
                        });
                        product_list_message  = product_list_message + "</ul>";


                        let subtotal_message = 'Subtotal: ' + displayed_product_data.subtotal;
                        let custom_message = "There was a change in the available stock. Kindly refer to your updated cart. Please click “Proceed” to accept the changes and continue with your order."+product_list_message+"";
                        var update_product_merchant  = false;

                        if(updated_products.change_quantity == true)
                        {
                          let show_popup = this.$refs.confirmDialogue.show({
                              title: "You have items in your Cart",
                              message: custom_message,
                              okButton: 'Proceed',
                              cancelButton: 'Cancel'
                          });

                          show_popup.then((response)=>{
                             if(response)
                            {
                              var new_cart_products = [];

                               this.products.forEach( (p,p_index)=>{
                                updated_products.products.forEach( (np,np_index)=>{
                                  var sku_raw = p.product.sku.substring(0, p.product.sku.indexOf("-"));
                                  if(np.product.sku.includes(sku_raw))
                                  {
                                    new_cart_products.push({
                                      product: np.product,
                                      quantity: np.new_qty,
                                    });
                                  }
                                });
                              });

                              Location.setLocation({
                                  "province": this.province,
                                  "city": this.city,
                                  "barangay": this.barangay
                              });

                              this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products = new_cart_products;
                              this.ShoppingCart.setCart(this.ShoppingCart.cart);

                              
                              this.products = this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products;

                              resolve(validation_result);

                            
                            }
                            else
                            {
                              validation_result.status = 'failed';
                              validation_result.message = 'Change Location Cancelled'
                              resolve(validation_result);
                            }

                          });
                        }
                        else
                        {
                            var new_cart_products = [];

                             this.products.forEach( (p,p_index)=>{
                              updated_products.products.forEach( (np,np_index)=>{
                                var sku_raw = p.product.sku.substring(0, p.product.sku.indexOf("-"));
                                if(np.product.sku.includes(sku_raw))
                                {
                                  new_cart_products.push({
                                    product: np.product,
                                    quantity: np.new_qty,
                                  });
                                }
                              });
                            });

                            Location.setLocation({
                                "province": this.province,
                                "city": this.city,
                                "barangay": this.barangay
                            });

                            this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products = new_cart_products;
                            this.ShoppingCart.setCart(this.ShoppingCart.cart);

                            
                            this.products = this.ShoppingCart.cart[this.ShoppingCart.active_shopping_cart].products;

                            resolve(validation_result);

                        }
                  }

              });
          }
          else
          {
            resolve(validation_result);
          }
        });
     },
     async checkInventory()
     {
       return new Promise((resolve, reject) => {
         var validation_result = {
            status: 'success',
            message: 'Valid Inventory'
          };
          var check_products = [];

            this.products.forEach((product, product_index)=>{
                check_products.push({
                  sku_id: product.product.sku,
                  quantity: product.quantity
                })
            });

            var inventory_check = ProductAPI.checkInventory(check_products);
            inventory_check.then((inventory_check_response)=>{
       
                var all_instock = true;
                if(!inventory_check_response)
                {

                  validation_result.status = "failed";
                  validation_result.message = "Unable to Place Order. Error occured while checking inventory";

                  resolve(validation_result);
                }
                else
                {
                  // Check each products stock status. if one product is out of stock or limited stock, set all_instock to false
                  inventory_check_response.forEach((product, product_key)=> {
                    if( !( (product.status == 'success_in_stock' || product.status == 'success_not_inventoriable') && product.code == "success"))
                    {
                      all_instock = false;
                    }
                  });
                  // NEW STOCK CHECK - End

                  if(!all_instock)
                  {
                    console.log("remove out of stock products");
                    resolve(validation_result);
                  }
                  else
                  {
                    resolve(validation_result);
                  }
                }
              
            });

        });
     },
    async placeOrder()
    {
      var process_order = true;
      var confirm_new_account = false;
      this.submit = true;
      
      var merchant_product_checked = await this.merchantProductChecking();
      if(merchant_product_checked.status == 'failed')
      {
        process_order = false;
         this.submit = false;
        this.show_error = true;
        this.error_message = merchant_product_checked.message;
        this.$refs['billing'].scrollIntoView({ behavior: 'smooth', block: "center" });
      }
      else if(merchant_product_checked.status == 'success' && !this.products.length)
      {
        process_order = false;
        this.submit = false;
         var redirect_home = await this.$refs.alertDialogue.show({
              title: "Your Cart is now Empty",
              message: "Some of the products you selected are not available in your selected area.",
              okButton: 'Back to Home',
         
          });

          if(redirect_home)
          {
             this.$router.push('/');
          }
      }


      var inventory_checked = await this.checkInventory();
      if(inventory_checked.status == 'failed')
      {
        process_order = false;
         this.submit = false;
        this.show_error = true;
        this.error_message = inventory_checked.message;
        this.$refs['billing'].scrollIntoView({ behavior: 'smooth', block: "center" });
      }
     
      if(process_order)
      {

            try {
             this.submit = true;
             this.show_error = false;
             this.error_message = "";

             var validate_order = this.validateOrder();
             validate_order.then((validation_result)=>{
              if(validation_result.status == "failed")
              {
                this.submit = false;
                this.show_error = true;
                this.error_message = validation_result.message;
                 this.$refs['billing'].scrollIntoView({ behavior: 'smooth', block: "center" });
              }
              else
              {
                var placed_products = [];
                this.products.forEach((product, product_index) => {
                   placed_products.push({
                     sku_id: product.product.sku,
                     quantity: product.quantity,
                     product_price: product.product.product_price,
                   })
                 });
                var order = {
                    "order_type": "standard-delivery",
                    "created_via": "web",
                    "customer_type": "account",
                    "customer_id": this.customer_id,
                    "customer_ip_address": "",
                    "billing": {
                      "first_name": this.first_name,
                      "last_name": this.last_name,
                      "address_1": this.address,
                      "address_2": "",
                      "city": this.city,
                      "email": this.email_address,
                      "phone": this.mobile_number,
                      "barangay": this.barangay,
                      "province": this.province,
                      "landmark": this.landmark
                    },
                    "pickup_method": this.pickup_method,
                    "pickup_date": (this.pickup_method == 10 ?  util.getFormattedDate(new Date()) : this.pickup_date),
                    "pickup_time": "08:00 AM",
                    "payment_method": this.payment_method,
                    "products": placed_products,
                    "total_order_weight": ShoppingCart.getTotalCartWeight(),
                    "discount_tax": "",
                    "discount_total": 0,
                    "shipping_tax": "",
                    "shipping_total": this.delivery_fee,
                    "shipping_raw": "",
                    "shipping_total_breakdown": [],
                    "shipping_courier": "Default",
                    "cart_tax": "",
                    "total_tax": "",
                    "cart_discount": this.cart_discount,
                    "subtotal": this.subTotal,
                    "total": this.orderTotal,
                    "change_for": 0,
                    "customer_note": this.order_notes,
                    "free_delivery": this.free_delivery,
                    "voucher_code": this.voucher_code,
                    "sid": "",
                    "order_mode": "normal",
                    "replace_order": "",
                    "recipients": [],
                    "cart_hash": "",
                    "order_id": "",
                    };
               
                var existing_customer_address = this.inAccountAddress();
                if (Account.getLoginId() != '' && Account.getToken() != '')
                {
                  // Checkout via Logged In Account
                  if(!existing_customer_address)
                  {
                    // Checkout with new location
                    confirm_new_account = this.$refs.confirmDialogue.show({
                        title: "Location Not Registered in your Account",
                        message: 'The selected location is not registered in your account. Click "Proceed" to register this location and process this order',
                        okButton: 'Proceed',
                        cancelButton: 'Cancel'
                    });

                    confirm_new_account.then((response)=>{
                      if(response)
                      {
                        try{

                          var create_account_request = AccountAPI.createSubAccount( this.province.province_code,this.city.city_code, this.barangay.brgy_code, this.address, this.email_address, Account.getLoginId(), Account.getToken());
                          create_account_request.then((new_account)=>{
                           
                            if(new_account.status == 'Failed.')
                            {
                                    this.error_message = new_account.message;
                                    this.show_error = true;
                                    this.submit = false;
                                    this.$refs['billing'].scrollIntoView({ behavior: 'smooth', block: "center" })
                            }
                            else
                            {
                                order.customer_id = new_account.data.customer_id;
                              
                                var order_request = OrderAPI.submitOrder(order);
                                order_request.then((order_submit)=>{
                                  if(order_submit.order_response == 'success')
                                  {

                                    sessionStorage.setItem("order_success", JSON.stringify(order_submit));
                                     

                                      if(Account.getToken() == "" || Account.getLoginId() == "")
                                      {
                                      }
                                      else
                                      {
                                        // this.products.forEach((p,p_index)=>{
                                        //   ShoppingCart.removeFromCart(p.product, 0);
                                        // });
                                      }


                                    setTimeout(()=>{
                                    this.removeVoucher();
                                      // ShoppingCart.deleteCart();
                                      this.$router.push('/checkout/order/success');
                                    },1000);
                                  } else {

                                     this.error_message = "Error Submitting Order. Please try Again Later";
                                    this.show_error = true;
                                    this.submit = false;
                                    this.$refs['billing'].scrollIntoView({ behavior: 'smooth', block: "center" })
                                    
                                  }

                                });

                            }

                          });
                        }
                        catch (e)
                        {
                          console.log(e);
                        }
                      }

                    });
                  }
                  else
                  {
                    // Checkout with registered location
                     var order_request = OrderAPI.submitOrder(order);
                      order_request.then((order_submit)=>{
                        if(order_submit.order_response == 'success')
                        {
                          sessionStorage.setItem("order_success", JSON.stringify(order_submit));
                       
                          
                          // If not logged in, clear customer id
                          if(Account.getToken() == "" || Account.getLoginId() == "")
                          {
                            Account.setCustomerID("");
                          }
                          else
                          {
                            // this.products.forEach((p,p_index)=>{
                            //   ShoppingCart.removeFromCart(p.product, 0);
                            // });
                          }

                          setTimeout(()=>{
                               // ShoppingCart.deleteCart();
                               this.removeVoucher();
                            this.$router.push('/checkout/order/success');
                          },1000);
                        } else {
                          this.error_message = "Unable to Checkout. Please try again later";
                          this.show_error = true;
                          this.submit = false;
                          this.$refs['billing'].scrollIntoView({ behavior: 'smooth', block: "center" })
                        }

                      });

                  }

                }
                else
                {
                  // Checkout via Registered Account only

                   if(this.barangay.brgy_code != Account.info.barangay.brgy_code)
                   {
                     // Checkout with new location
                       confirm_new_account = this.$refs.confirmDialogue.show({
                        title: "Location Not Registered in your Account",
                        message: 'The selected location is not registered in your account. Click "Proceed" to register this location and process this order',
                        okButton: 'Proceed',
                        cancelButton: 'Cancel'
                    });

                    confirm_new_account.then((response)=>{
                      if(response)
                      {
                        try{

                          var create_account_request = AccountAPI.register(
                              Account.info.first_name,
                              Account.info.last_name,
                              Account.info.position,
                                Account.info.telephone_number,
                                Account.info.mobile_number,
                                Account.info.email_address,
                                "",
                                false,
                                true,
                                Account.info.registered_business_name,
                                Account.info.trade_name,
                                this.address,
                                this.province,
                                this.city,
                                this.barangay,
                                Account.info.sec_no,
                                Account.info.dti_no,
                                Account.info.tin_no,
                                Account.info.uuid,
                            );
                          create_account_request.then((new_account)=>{
                           
                            if(new_account.status == 'Failed.')
                            {
                                    this.error_message = new_account.message;
                                    this.show_error = true;
                                    this.submit = false;
                                    this.$refs['billing'].scrollIntoView({ behavior: 'smooth', block: "center" })
                            }
                            else
                            {
                                
                                order.customer_id = new_account.data.customer_id;
                           
                                var order_request = OrderAPI.submitOrder(order);
                                order_request.then((order_submit)=>{
                                  if(order_submit.order_response == 'success')
                                  {
                                    sessionStorage.setItem("order_success", JSON.stringify(order_submit));

                                    setTimeout(()=>{

                                    this.removeVoucher();
                                      // ShoppingCart.deleteCart();
                                      this.$router.push('/checkout/order/success');
                                    },1000);
                                  } else {

                                     this.error_message = "Error Submitting Order. Please try Again Later";
                                    this.show_error = true;
                                    this.submit = false;
                                    this.$refs['billing'].scrollIntoView({ behavior: 'smooth', block: "center" })
                                    
                                  }

                                });

                            }

                          });
                        }
                        catch (e)
                        {
                          console.log(e);
                        }
                      }

                    });

                   }
                   else
                   {
                    // Checkout with registered location
                      var order_request = OrderAPI.submitOrder(order);
                      order_request.then((order_submit)=>{
                        if(order_submit.order_response == 'success')
                        {
                          sessionStorage.setItem("order_success", JSON.stringify(order_submit));
                       

                          setTimeout(()=>{
                            
                                    this.removeVoucher();
                               // ShoppingCart.deleteCart();
                            this.$router.push('/checkout/order/success');
                          },1000);
                        } else {
                          this.error_message = "Unable to Checkout. Please try again later";
                          this.show_error = true;
                          this.submit = false;
                          this.$refs['billing'].scrollIntoView({ behavior: 'smooth', block: "center" })
                        }

                      });
                   }
                }
              }
             });
             
            } catch(error) {

                          console.log(e);
              this.error_message = error;
              this.show_error = true;
              this.submit = false;
              this.$refs['billing'].scrollIntoView({ behavior: 'smooth', block: "center" })
            }
        
      }

      
    },
    inAccountAddress()
    {
      var in_address = false;

      var addresses = Account.getAddresses();
      addresses.forEach((address, address_index)=>{
        if(address.brgy_code == this.barangay.brgy_code && address.city_code == this.city.city_code && address.province_code == this.province.province_code)
        {
          in_address = true;
        }
      });

      return in_address;
    },
    async validateOrder()
    {
      var validation_result = {
        status: 'success',
        message: 'Valid Order'
      };

      try {
        return new Promise((resolve, reject) => {
          if(this.first_name == "")
          {
            validation_result.status = "failed";
            validation_result.message = "Please enter your First Name";
             resolve(validation_result);
          }
          else if(this.last_name == "")
          {
            validation_result.status = "failed";
            validation_result.message = "Please enter your Last Name";
             resolve(validation_result);
          }
          else if(this.mobile_number == "" || this.mobile_number == null)
          {
            validation_result.status = "failed";
            validation_result.message = "Please enter your Mobile Number";
             resolve(validation_result);
          }
          else if( !(/^(09|639)\d{9}$/).test(this.mobile_number) )
          {
            validation_result.status = "failed";
            validation_result.message = "Please enter a valid Mobile Number";
             resolve(validation_result);
          }
          else if(this.email_address == "")
          {
            validation_result.status = "failed";
            validation_result.message = "Please enter your Email Address";
             resolve(validation_result);
          }
          else if(this.province.province_code == "" || this.province.province_name == "")
          {
            validation_result.status = "failed";
            validation_result.message = "Please select a Province";
             resolve(validation_result);
          }
          else if(this.city.city_code == "" || this.city.city_name == "")
          {
            validation_result.status = "failed";
            validation_result.message = "Please select a City";
             resolve(validation_result);
          }
          else if(this.barangay.brgy_code == "" || this.barangay.brgy_name == "")
          {
            validation_result.status = "failed";
            validation_result.message = "Please select a Barangay";
             resolve(validation_result);
          }
          else if(this.address == "" || !this.address)
          {
            validation_result.status = "failed";
            validation_result.message = "Please enter your address";
             resolve(validation_result);
          }
          else if(this.pickup_method == null || this.pickup_method == 0)
          {
            validation_result.status = "failed";
            validation_result.message = "Please select a Shipping Method";
             resolve(validation_result);
          }
          else if(this.payment_method == null || this.payment_method == 0)
          {
            validation_result.status = "failed";
            validation_result.message = "Please select a Shipping Method";
             resolve(validation_result);
          }
          else if(this.products.length <= 0)
          {
            validation_result.status = "failed";
            validation_result.message = "Unable to Place Order. No Product in the Cart";

             resolve(validation_result);
          }
          else if(this.free_shipping == false && this.delivery_fee <= 0)
          {
            validation_result.status = "failed";
            validation_result.message = "Unable to Place Order. Invalid Shipping Fee";

             resolve(validation_result);
          }
          else
          {

            resolve(validation_result);
          }

        });
      } catch (error) {
        console.log(error);
      }
    },
    async loadShippingMethods() {
       var shipping_methods_data = {
        status: 'success',
        shipping_methods: [],
      };
       return new Promise((resolve, reject) => {
        try {
          var location = Location.getLocation();

          var shipping_method_request = ShippingAPI.getShippingMethods(location.barangay.brgy_code)
          shipping_method_request.then((response) => {
              if(response.shipping_method)
              {
                var default_method = response.shipping_method[0];

                   this.pickup_method = default_method.id; // Set Same Day Delivery as Default
                   this.pickup_date = moment().add(1,'day').format("L").toString();
                  this.shipping_method_list = response.shipping_method;
                  this.calendar_disabled_dates = response.disabled_date;
                  
                  shipping_methods_data.shipping_methods = this.shipping_method_list;
                  resolve(shipping_methods_data);
              }
              else
              {
                shipping_methods_data.status = "failed";
                resolve(shipping_methods_data);
              }
              
        
          })
        } catch (error) {
          shipping_methods_data.status = 'failed';
          resolve(shipping_methods_data);
           console.log(error)
        }
      });
    },
    async loadPaymentMethods() {
       var paymentmethod_data_response = {
        status: 'success',
        payment_method: [],
      };
       return new Promise((resolve, reject) => {
          try {
            var location = Location.getLocation();
            var payment_method_request = PaymentAPI.getPaymentMethods(location.barangay.brgy_code)
            payment_method_request.then((response) => {
                if(response.status == 'success')
                {
                    this.payment_method_list = response.result;
                    paymentmethod_data_response.payment_method = this.payment_method_list;
                    resolve(paymentmethod_data_response);
                }
                else
                {
                   paymentmethod_data_response.status = "failed";
                   resolve(paymentmethod_data_response);
                }
            });
          } catch (error) {
             console.log(error)
             paymentmethod_data_response.status = "failed";
             resolve(paymentmethod_data_response);
          }
        });
    },
     async loadLocationData(barangay_code)
    {
      
      this.barangay_list.forEach((b, b_index)=>{
        if(b.brgyCode == barangay_code)
        {
          this.barangay.brgy_name = b.brgyDesc;
        }
      });

    },
    async loadProvinces() {
      var province_data_response = {
        status: 'success',
        provinces: [],
      };
       return new Promise((resolve, reject) => {
        try {
          var province_request = LocationAPI.getProvinces()
          province_request.then((response) => {
            if (response.length) {
              this.province_list = response;
              province_data_response.provinces = this.province_list;
              resolve(province_data_response);
            }
          })
        } catch (error) {
           console.log(error);
           province_data_response.status = "failed";
           resolve(province_data_response);
        }
      });
    },
    async loadCities (province_code) {
      this.city_list = [];
      this.barangay_list = [];
       
      this.province_list.forEach((p, p_index)=>{
        if(p.psgcCode == province_code)
        {
          this.province.province_name = p.provDesc;
        }
      });

      setTimeout(()=>{
        var city_request = LocationAPI.getCities(province_code)
        city_request.then((response) => {
          if (response.length) {
            this.city_list = response;
          }
        })
      },200);
    },
    async loadBarangay (city_code) {
      this.barangay_list = [];

        this.city_list.forEach((ct, ct_index)=>{
        if(ct.citymunCode == city_code)
        {
          this.city.city_name = ct.citymunDesc;
        }
      });
     
      setTimeout(()=>{
        var barangay_request = LocationAPI.getBarangay(city_code)
        barangay_request.then((response) => {
          if (response.length) {
            this.barangay_list = response
          }
        })

      },200);
    },
    getProductPrice(product)
    {

      if(product.product.sale_type == 'default')
      {
        return (product.product.product_price * product.quantity);
      }
      else
      {
     
            var has_price_off_promo = false;
            var price_off_promo_index = 0;
 
            if(product.product.promo)
            {
              product.product.promo.forEach((promo, promo_index)=>{
                if(typeof promo == 'object' && !Array.isArray(promo)) {
                  if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                  {
                   
                     var passed_product_requirements = 0;
                   promo.required_items.forEach((ri,ri_index)=>{
                     ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                      if(p.product.sku == ri.sku_id)
                      {
                        passed_product_requirements+=1;
                      }
                    });
                  });

                    if(passed_product_requirements == promo.required_items.length)
                  {
                    
                      if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                      {

                        if(has_price_off_promo)
                        {

                          if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                          {
                            price_off_promo_index = promo_index;
                                has_price_off_promo = true;
                          }

                        }
                        else
                        {

                           price_off_promo_index = promo_index;
                             has_price_off_promo = true;
                          }
                      }
                 
                  }

                  }
                }
              });
            }


             if(has_price_off_promo)
             {
              return (product.product.sale_price * product.quantity)
              
            }
            else
            {
                return (product.product.product_price == parseFloat(product.product.product_sale_price) ? (product.product.product_price * product.quantity) : (product.product.product_sale_price * product.quantity));
                
            }

      }

    },
    getProductPromoDescription(product)
    {
   	  if(product.product.sale_type == 'fixed' || product.product.sale_type == 'percentage' || product.product.sale_type == 'promo')
      {
        if(product.product.sale_type == 'promo')
        {

            var has_price_off_promo = false;
            var price_off_promo_index = 0;
 
            if(product.product.promo)
            {
              product.product.promo.forEach((promo, promo_index)=>{
                if(typeof promo == 'object' && !Array.isArray(promo)) {
	                if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
	                {
	           			
	                   var passed_product_requirements = 0;
		               promo.required_items.forEach((ri,ri_index)=>{
		                 ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
		                  if(p.product.sku == ri.sku_id)
		                  {
		                    passed_product_requirements+=1;
		                  }
		                });
		              });

		                if(passed_product_requirements == promo.required_items.length)
			            {
		                
			                if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
			                {

			                	if(has_price_off_promo)
			                	{

			                		if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
			                		{
			                			price_off_promo_index = promo_index;
		                  		  		has_price_off_promo = true;
			                		}

			                	}
			                	else
			                	{

				                   price_off_promo_index = promo_index;
		                  		   has_price_off_promo = true;
		                  		}
			                }
			           
			            }

	                }
	              }
              });
            }

	           if(has_price_off_promo)
	           {
            	return (product.product.promo[price_off_promo_index].promo_description)
	            
	          }
	          else
	          {

	              return '';
	          }

        }
        else
        {
          return '';
        }

      }
      else
      {
        return '';
      }

    },

    hasProductPromo(product)
    {

      if(product.product.sale_type == 'promo' && product.product.promo)
      {
        if(product.product.sale_type == 'promo')
        {

            var has_applicable_promo = false;
            var applicable_promo_index = 0;
            product.product.promo.forEach((promo, promo_index)=>{
              if(typeof promo == 'object' && !Array.isArray(promo)) {
              if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT' || (promo.promo_type).toUpperCase() == 'FREE GIFT')
              {
                var passed_product_requirements = 0;
                promo.required_items.forEach((ri,ri_index)=>{
                   ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                    if(p.product.sku == ri.sku_id)
                    {
                      passed_product_requirements+=1;
                    }
                  });
                });

                if(passed_product_requirements == promo.required_items.length)
                {
                
                   if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
	                {

                  		applicable_promo_index = promo_index;
	                	has_applicable_promo = true;
	                }
                }
              }
            }
            });

            
           if(has_applicable_promo)
           {
             return true;
           }
           else
           {
             return null;
           }

        }
        else
        {
          return null;
        }

      }
      else
      {
        return null;
      }

    },

    getProductSlashedPrice(product)
    {
      if(product.product.sale_type == 'default')
      {
        return (0);
      }
      else
      {
       
            var has_price_off_promo = false;
            var price_off_promo_index = 0;
            if(product.product.promo) {
              product.product.promo.forEach((promo, promo_index)=>{
                if(typeof promo == 'object' && !Array.isArray(promo))
                {
                  if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                  {
                
                      var passed_product_requirements = 0;
                   promo.required_items.forEach((ri,ri_index)=>{
                     ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                      if(p.product.sku == ri.sku_id)
                      {
                        passed_product_requirements+=1;
                      }
                    });
                  });

                    if(passed_product_requirements == promo.required_items.length)
                  {
                    
                      if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                      {

                        if(has_price_off_promo)
                        {

                          if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                          {
                            price_off_promo_index = promo_index;
                                has_price_off_promo = true;
                          }

                        }
                        else
                        {

                           price_off_promo_index = promo_index;
                             has_price_off_promo = true;
                          }
                      }
                 
                  }
                  }
                }
              });
            }


          if(has_price_off_promo)
          { 
            return (product.product.original_price * product.quantity);   
          }
          else
          {
           return (product.product.product_price == parseFloat(product.product.product_sale_price) ? 0 : (product.product.original_price * product.quantity));
          }

     

      }
    }
  }
    
}
</script>

<template>
  <div class="page checkout-page">
    <HeaderFive />
      <div class="preloader" id="preloader" v-if="!loaded">
        <div class="preloader-inner">
            <div class="spinner">
                <div class="dot1"></div>
                <div class="dot2"></div>
            </div>
            <div class="preloader-title"><h5>Loading Checkout...</h5></div>
        </div>
    </div>

    <!-- BREADCRUMB AREA START -->
    <div class="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-image" data-bg="/static/img/bg/9.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                        <div class="section-title-area ltn__section-title-2">
                            <!-- <h6 class="section-subtitle ltn__secondary-color">//  Welcome to our company</h6> -->
                            <h1 class="section-title white-color">Checkout</h1>
                        </div>
                        <div class="ltn__breadcrumb-list">
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li>Checkout</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BREADCRUMB AREA END -->

    <!-- WISHLIST AREA START -->
    <div class="ltn__checkout-area mb-105">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__checkout-inner">
                        <div class="ltn__checkout-single-content ltn__returning-customer-wrap">
                            <!-- <h5>Returning customer? <a class="ltn__secondary-color" href="#ltn__returning-customer-login" data-toggle="collapse">Click here to login</a></h5> -->
                            <div id="ltn__returning-customer-login" class="collapse ltn__checkout-single-content-info">
                                <div class="ltn_coupon-code-form ltn__form-box">
                                    <p>Please login your accont.</p>
                                    <form action="#" >
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="input-item input-item-name ltn__custom-icon">
                                                    <input type="text" name="ltn__name" placeholder="Enter your name">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="input-item input-item-email ltn__custom-icon">
                                                    <input type="email" name="ltn__email" placeholder="Enter email address">
                                                </div>
                                            </div>
                                        </div>
                                        <button class="btn theme-btn-1 btn-effect-1 text-uppercase">Login</button>
                                        <label class="input-info-save mb-0"><input type="checkbox" name="agree"> Remember me</label>
                                        <p class="mt-30"><a href="register.html">Lost your password?</a></p>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <h5 v-if="show_error" class="alert alert-danger" role="alert">{{ error_message }}</h5 >
                        <div class="ltn__checkout-single-content ltn__coupon-code-wrap">
                            <h5>Have a voucher? <a class="ltn__secondary-color" href="#ltn__coupon-code" data-toggle="collapse">Click here to enter your code</a></h5>
                            <div id="ltn__coupon-code" class="collapse ltn__checkout-single-content-info">
                                <div class="ltn__coupon-code-form">
                                  <div class="voucher-input no-voucher" v-if="voucher_code == '' && !voucher_promo">
                                    <p>If you have a voucher code, please redeem it below.</p>
                                    <div>
                                        <input type="text" name="coupon-code" v-model="input_voucher" placeholder="Add Voucher Code" :disabled="voucher_code != ''">
                                        <button @click="applyVoucher()" class="btn theme-btn-2 btn-effect-2 text-uppercase" >{{ loading_voucher ? 'Redeeming Voucher...' : 'Redeem'}}</button>
                                    </div>
                                  </div>
                                   <div class="voucher-input active-voucher" v-if="voucher_code != '' && voucher_promo">
                                    <p>You have an active voucher.</p>
                                    <div>
                                        <h2 class="ltn__secondary-color mb-0">{{ voucher_code }}</h2>
                                        <p><small>{{ voucher_promo.promo_description }}</small></p>
                                        <button @click="removeVoucher()" class="btn theme-btn-2 btn-effect-2 text-uppercase" >{{ loading_voucher ? 'Removing Voucher...' : 'Remove'}}</button>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="ltn__checkout-single-content mt-20 placeholderColor">
                            <div class="ltn__checkout-single-content-info">
                              <h4 class="title-2" ref="billing">Contact Information</h4>
                                <form action="#" >
                                     
                                    <div class="row">
                                        <div class="col-md-6">

                                           <h6>First Name <span style="color: red;">*</span></h6>
                                            <div class="input-item input-item-name ltn__custom-icon">
                                                <input type="text" v-model="first_name" name="ltn__name" placeholder="First name">
                                            </div>
                                        </div>
                                        <div class="col-md-6">

                                           <h6>Last Name <span style="color: red;">*</span></h6>
                                            <div class="input-item input-item-name ltn__custom-icon">
                                                <input type="text" v-model="last_name" name="ltn__lastname" placeholder="Last name">
                                            </div>
                                        </div>
                                       
                                        <div class="col-md-6">

                                           <h6>Mobile Number <span style="color: red;">*</span></h6>
                                            <div class="input-item input-item-phone ltn__custom-icon">
                                                <input type="text" v-model="mobile_number" maxlength="12" name="ltn__phone"  placeholder="Mobile Number (e.g. 09xxxxxxxxx)">
                                            </div>
                                        </div>

                                         <div class="col-md-6">

                                           <h6>Email Address <span style="color: red;">*</span></h6>
                                            <div class="input-item input-item-email ltn__custom-icon">
                                                <input type="email" v-model="email_address" name="ltn__email" placeholder="Email Address">
                                            </div>
                                        </div>

                                        <div class="col-md-6">

                                           <h6>Telephone Number</h6>
                                            <div class="input-item input-item-phone ltn__custom-icon">
                                                <input type="text" v-model="tel_number" maxlength="10" name="ltn__phone"  placeholder="Telephone Number (e.g. 02xxxxxxxx) ">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-4" v-if="is_logged_in">
                                       
                                        <div class="col-lg-6 col-md-6">
                                            <h6>Delivery Address <span style="color: red;">*</span></h6>
                                            <div class="input-item">
                                              <select class="c-select" @change="selectMyAddress" v-model="active_account_address">
                                                <option selected disabled value="">Select Address</option>
                                                <option value="new">Add New Address</option>
                                                <option v-for="(address,indx) in my_addresses" :value="indx">{{ address.brgy_name + ', ' + address.city_name + ', ' + address.province_name }}
                                                </option>
                                              </select>

                                            </div>
                                            <!---
                                            <div class="input-item">
                                              <input type="checkbox" id="new_address" v-model="new_address" />
                                              <label for="new_address">New Address</label>
                                              
                                            </div>
                                            -->
                                        </div>
                                        <!--  <div class="col-lg-6 col-md-6">
                                            <h6>Address to use</h6>
                                            <div class="input-item mb-4 mt-4">
                                               <input type="radio" id="one" value="1" v-model="new_address" />
                                              <label for="one" class="mr-4">New Location</label>

                                              <input type="radio" id="two" value="0" v-model="new_address" />
                                              <label for="two">Select from my Addresses</label>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="row">
                                       <div class="col-lg-12 col-md-12 ">
                                            <h6>Unit No. / Building / Street Name <span style="color: red;">*</span></h6>
                                            <div class="input-item">
                                                <input class="" v-if="new_address" type="text" v-model="address" placeholder="House Number and Street Name">
                                                <input class="" v-if="!new_address" type="text" disabled v-model="address" placeholder="House Number and Street Name">
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6">
                                            <h6>Province <span style="color: red;">*</span></h6>
                                            <div class="input-item">
                                              <select v-if="new_address" @change="loadCities(province.province_code)" class="c-select" v-model="province.province_code">
                                                <option selected disabled value="">Select Province</option>
                                                <option v-for="province in province_list" :value="province.psgcCode">{{ province.provDesc }}</option>
                                              </select>
                                              <input v-if="!new_address" type="text" disabled :value="province.province_name" name="ltn__phone" placeholder="Province">
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6">
                                            <h6>City <span style="color: red;">*</span></h6>
                                            <div class="input-item">
                                                <select v-if="new_address" @change="loadBarangay(city.city_code)" class="c-select" v-model="city.city_code" :disabled="!city_list.length">
                                                    <option selected disabled value="">Select City</option>
                                                    <option v-for="city in city_list" :value="city.citymunCode">{{ city.citymunDesc }}</option>
                                                 </select>
                                                <input v-if="!new_address" type="text" disabled :value="city.city_name" name="ltn__phone" placeholder="City">
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6">
                                            <h6>Barangay <span style="color: red;">*</span></h6>
                                            <div class="input-item">
                                                <select v-if="new_address" class="c-select" @change="loadLocationData(barangay.brgy_code)" v-model="barangay.brgy_code" :disabled="!barangay_list.length">
                                                    <option selected disabled value="">Select Barangay</option>
                                                    <option v-for="barangay in barangay_list" :value="barangay.brgyCode">{{ barangay.brgyDesc }}</option>
                                              </select>
                                              <input type="text" disabled v-if="!new_address" :value="barangay.brgy_name" name="ltn__phone" placeholder="Barangay">
                                            </div>
                                        </div>
                                       
                                    </div>
                                    <!-- <p><label class="input-info-save mb-0"><input type="checkbox" name="agree"> Create an account?</label></p> -->
                                   
                                    <div class="row">
                                       <div class="col-lg-6">
                                            <h6>Landmark (optional) </h6>
                                            
                                            <div class="input-item">
                                              <input v-if="new_address" type="text" v-model="landmark">
                                              <input v-if="!new_address" disabled type="text" v-model="landmark">
                                            </div>
                                        </div>
                                        <div class="col-lg-12">
                                          <h6>Order Notes (optional)</h6>
                                          <div class="input-item input-item-textarea ltn__custom-icon">
                                              <textarea name="ltn__message" v-model="order_notes" placeholder="Additional Delivery Instructions (e.g. Delivery Time)"></textarea>
                                          </div>

                                        </div>
                                       
                                       
                                    </div>
                                    

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="ltn__checkout-payment-method mt-50">
                        <h4 class="title-2">Shipping Method <span style="color: red;">*</span></h4>
                        <div id="checkout_accordion_1">
                            <!-- card -->
                            <div class="card" v-for="ship_method in shipping_method_list" @click="selectShippingMethod(ship_method)">
                            
                                <h5 class="collapsed ltn__card-title" :aria-expanded="pickup_method == ship_method.id" :disabled="ship_method.pickup_code == 'same_day_delivery' && delivery_cutoff == true" data-toggle="collapse" :data-target="'#ship_method_' + ship_method.id">
                                    <label :for="ship_method.id" class="mb-0">{{ ship_method.pickup_method }}  <i>
                                        <small v-if="ship_method.pickup_code == 'same_day_delivery'"> (Order Cutoff at 5:00 PM)</small>
                                        <small v-if="ship_method.pickup_code == 'scheduled_shipping'"> (Delivery within 3-5 days)</small>
                                      </i></label>
                                    <input type="radio" :disabled="ship_method.pickup_code == 'same_day_delivery' && delivery_cutoff == true" class="invisible" :id="ship_method.id" :value="ship_method.id" v-model="pickup_method" />
                                </h5>
                                <div :id="'#ship_method_' + ship_method.id" class="collapse" data-parent="#checkout_accordion_1" :class="{'show' : pickup_method == ship_method.id }" v-if="ship_method.pickup_code == 'same_day_delivery' || ship_method.pickup_code == 'scheduled_shipping'">
                                    <div class="card-body">
                                        <p class="shipping-disclaimer" v-if="ship_method.pickup_code == 'same_day_delivery'">In line with the policies of the Land Transportation Office, one rider can only carry up to 20kg. Hence, the 150-peso shipping fee for same day delivery orders will be charged per 20kg.<br><br>For example, if an order has a total weight of 25kg, total shipping fee will be 300 pesos (150 pesos x 2) because 2 riders will be needed to deliver the full order.<br><br>If you agree, please continue and proceed to checkout.</p>

                                        <p class="shipping-disclaimer" v-if="ship_method.pickup_code == 'scheduled_shipping'">Our distributors have a specific delivery schedule in your area. Kindly expect 3-5
                                          days lead time. You will receive an update via SMS and email once your order has been processed and is
                                          ready for delivery.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                    <div class="ltn__checkout-payment-method mt-50">
                        <h4 class="title-2">Payment Method <span style="color: red;">*</span></h4>
                        <div id="checkout_accordion_1">
                            <!-- card -->
                            <div class="card" v-for="pay_method in payment_method_list">
                                <h5 class="collapsed ltn__card-title" :aria-expanded="payment_method == pay_method.payment_method_id">
                                  
                                    <label :for="pay_method.payment_method_id" class="mb-0">{{ pay_method.payment_method_name }}</label>
                                    <input type="radio" class="invisible" :id="pay_method.payment_method_id" :value="pay_method.payment_method_id" v-model="payment_method" />
                                </h5>
                                <div id="'#pay_method_' + pay_method.payment_method_id" class="collapse" data-parent="#checkout_accordion_1" :class="{'show' : payment_method == pay_method.payment_method_id }"
                                v-if="(pay_method.payment_method_name).toLowerCase() == 'cash on delivery'">
                                    <div class="card-body">
                                        <p class="shipping-disclaimer"> For new customers, payment will be cash on delivery. For existing customers of the
                                          distributors, your current payment method will be followed together with your existing terms.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
              
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="shoping-cart-total mt-50">
                        
                        <table class="table">
                            <tbody>
                                 <tr v-for="test in test_products">
                                   <td>
                                   {{test.product.product_name}}
                                   </td>
                                   <td>

                                   {{test.product.product_price}}
                                   </td>
                                 </tr>
                                <tr v-for="product in products">
                                    <td>
                                      <div class="regular-sitewide-price" v-if="!product.voucher_discount">
                                        <div class="product-nameqty"><div class="product-name text-truncate">{{ product.product.product_name }}</div><strong> × {{ product.quantity }}</strong></div>
                                        <div class="promo-details text-left" v-if="hasProductPromo(product)">
                                             <small>
                                               <div>{{  getProductPromoDescription(product) }}</div>
                                               </small>
                                       

                                        </div>
                                      </div>
                                      <div class="voucher-price" v-if="product.voucher_discount">
                                         <div class="product-nameqty"><div class="product-name text-truncate">{{ product.product.product_name }}</div><strong> × {{ product.quantity }}</strong></div>
                                        <div class="promo-details text-left">
                                          <span v-if="voucher_promo.promo_type.toLowerCase() == 'price discount'">{{ voucher_promo.promo_description }}</span>
                                        </div>
                                        
                                      </div>
                                    </td>
                                    <td>

                                        <div class="regular-sitewide-price" v-if="!product.voucher_discount">
                                          <div > {{ getProductPrice(product) | currencyFormat }} </div>
                                          <div class="promo-details text-right" v-if="hasProductPromo(product) && getProductSlashedPrice(product) > 0">
                                            <del>{{ getProductSlashedPrice(product) | currencyFormat }}</del>
                                          </div>
                                        </div>
                                        <div class="voucher-price" v-if="product.voucher_discount">
                                           <div>
                                             {{ (product.voucher_discount.promo_price * product.quantity) | currencyFormat }}
                                           </div>
                                          <div class="promo-details text-right">
                                            <del>{{ getProductPrice(product) | currencyFormat }} </del>
                                          </div>
                                        </div>

                                        
                                    </td>
                                </tr>
                                 <tr v-for="free in free_gifts" class="free-gifts">
                                    <td>
                                      <div class="product-nameqty"><div class="product-name text-truncate">{{ free.product_name }}</div><strong> × {{ free.quantity }}</strong></div>
                                    </td>
                                    <td>
                                        <div> FREE </div>
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td>
                                      <h5>Cart Weight</h5>
                             
                                    </td>
                                    <td>
                                      <h5>{{ ShoppingCart.getTotalCartWeight() / 1000 }} kg</h5>
                                      
                                    </td>
                                </tr>
                                 <tr>
                                    <td>
                                      <h5>Weight Limit</h5>
                             
                                    </td>
                                    <td>
                                      <h5>{{ ShoppingCart.getCartWeightLimit() / 1000 }} kg</h5>
                                      
                                    </td>
                                </tr> -->
                                <tr>
                                    <td>
                                      <h5>Subtotal</h5>
                                      <div class="promo-details text-left" v-if="cart_promo.length && cart_discount > 0">
                                          <span v-for="cpromo of cart_promo">{{cpromo.promo_description}}<br></span>
                                       
                                        </div>
                                    </td>
                                    <td>
                                      <h5>{{ (subTotal - cart_discount <= 0 ? 0 : (subTotal - cart_discount)) | currencyFormat }}</h5>
                                       <div class="subtotal-promo promo-details" v-if="cart_promo.length && cart_discount > 0">
                                          <span v-for="cpromo of cart_promo">
                                            <span v-if="cart_promo.length >= 2">{{ cpromo.cart_discount | currencyFormat }} OFF</span>
                                            <del v-if="cart_promo.length <= 1">{{ subTotal | currencyFormat }}</del>
                                            <br>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Shipping Fee</h5>
                                        <div class="delivery-promo promo-details text-left"  v-if="delivery_promo.length && delivery_promo[delivery_promo.length - 1].original_delivery_charge > 0">
                                          <span v-for="dpromo of delivery_promo">{{dpromo.promo_description}}<br></span>
                                        </div>
                                    </td>
                                    <td class="placeholder-glow">
                                        <h5 class="test" :class="{'placeholder': calculating_shipping_fee }" v-if="!free_delivery">{{ (delivery_promo.length ? discounted_delivery_fee : delivery_fee ) | currencyFormat }}</h5>
                                        <h5 class="test" :class="{'placeholder': calculating_shipping_fee }" v-if="free_delivery">FREE</h5>
                                         <div class="delivery-promo promo-details" v-if="delivery_promo.length && delivery_promo[delivery_promo.length - 1].original_delivery_charge > 0">
                                          <span v-for="dpromo of delivery_promo">
                                            <span v-if="delivery_promo.length >= 2">{{ (dpromo.original_delivery_charge - dpromo.discounted_delivery_charge) | currencyFormat }} OFF</span>
                                            <del v-if="delivery_promo.length <= 1">{{ dpromo.original_delivery_charge | currencyFormat }}</del>
                                            <br>
                                          </span>
                                        </div>
                                     </td>
                                </tr>
                                <tr>
                                    <td><h5>Total</h5></td>
                                    <td><h5>{{ orderTotal | currencyFormat }}</h5></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="ltn__payment-note mt-30 mb-30">
                            <p>Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our privacy policy.</p>
                        </div>
                        <button class="btn theme-btn-1 btn-effect-1 text-uppercase" type="submit" :disabled="submit" @click="placeOrder">{{ submit ? 'Processing...' : 'Checkout' }}</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- WISHLIST AREA START -->
    <Footer />
       <AddToCartDialogue ref="addToCartDialogue" />
   <QuickviewDialogue ref="quickviewDialogue" />
    <ConfirmDialogue ref="confirmDialogue" />
    <AlertDialogue ref="alertDialogue" />
  </div>
</template>
<style scoped>
.preloader-title 
{
  position: absolute;
  margin-top: 8rem;
  color: #fff !important;
}
.preloader-title h5
{
  color: #fff !important;
}
.preloader-inner {
    background-color: #07141fcc;
}
.checkout-datepicker input {
    height: 3rem;
    margin: 0;
}
.delivery-promo {
    color: var(--ltn__secondary-color);
}
.product-name {
    display: inline-block;
    max-width: 280px;
    margin-right: 5px;
}
.product-nameqty {
    display: flex;
    align-items: center;
}

.shoping-cart-total table tr td:last-of-type * {
    text-align: right;
    width: 100%;
}
p.shipping-disclaimer {
    color: var(--ltn__secondary-color);
    font-size: 0.75rem;
}
.placeholder {
    color: #a6d0ff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Checkout.vue